module.exports = __webpack_public_path__ + "img/team2.3e98a931.avif";